import { FC } from "react";
import svgIcons from "../../assets/svg/svgIcons";
import FTModal from "../../components/common/FTModal";

type Props = {
  visible: boolean;
  eventCount: number;
  maxEvents: number;
  onHide: () => void;
};

// Shown when the user tries to plot a selection the map can't take. The
// count in the selector footer already says so; this is what happens when
// it's acted on anyway, so it names the numbers and what to do about them
// rather than just refusing.
export const EventLimitModal: FC<Props> = ({
  visible,
  eventCount,
  maxEvents,
  onHide,
}) => (
  <FTModal
    visible={visible}
    onHide={onHide}
    position="center"
    containerStyle="max-w-[calc(100vw-4rem)] w-[560px]"
  >
    <div className="relative text-center">
      <button
        type="button"
        onClick={onHide}
        aria-label="Close"
        className="absolute -top-2 -right-2 flex"
      >
        <img src={svgIcons.CloseIcon} alt="" className="size-8" />
      </button>

      <img
        src={svgIcons.WarningIcon}
        alt=""
        className="size-14 mx-auto mt-2 mb-4"
      />

      <h3 className="text-2xl font-bold text-heading-black">
        Event Limit Exceeded
      </h3>

      <p className="mt-3 text-sm text-heading-gray888">
        The selected vehicles contain{" "}
        <span className="font-semibold text-field-error-dark">
          {eventCount.toLocaleString()}
        </span>{" "}
        events, which exceeds the {maxEvents.toLocaleString()} event limit.
        Please deselect some vehicles to continue.
      </p>
    </div>
  </FTModal>
);
